<template>
<div id="">
  <v-container fluid class="pt-0 ">
    <v-row>
      <v-col cols="12" class="pt-0 ">
        <v-card style="min-height:85vh" class="admin_secondary">
          <v-card-title class="secondary white--text">
            Quality Card
            <v-spacer></v-spacer>
            <v-btn color="green" fab small class="mr-2" dark id="save-btn" @click="save" v-if="modified && !loading">
              <v-icon>fa-save</v-icon>
            </v-btn>
            <v-btn icon dark @click="load" :loading="loading">
              <v-icon>fa-sync</v-icon>
            </v-btn>
          </v-card-title>
          <v-tabs v-model="tab" background-color="secondary" dark :slider-size="4" centered fixed-tabs show-arrows>
            <v-tabs-slider color="primary"></v-tabs-slider>
            <v-tab v-for="(category,i,k) in project_report_categories" :key="k" :href="`#${i}`">
              {{category.label}}
            </v-tab>

          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(category,i,k) in project_report_categories" :key="k" :value="i">
              <category-view :value="category" @input="category = $event"></category-view>
            </v-tab-item>
          </v-tabs-items>
        </v-card>

      </v-col>
    </v-row>
  </v-container>

</div>
</template>
<script>
import category from "./category"
export default {
  name: "",
  components: {
    categoryView: category
  },
  created() {
    this.load()
  },
  data: () => ({
    tab: 'sound',
    currentTab: '',
    loading: false,
    modified: false,
    project_report_categories: {}
  }),
  watch: {
    'project_report_categories': {
      handler: function() {
        this.modified = true
      },
      deep: true
    }
  },
  computed: {

  },
  async beforeRouteLeave(to, from, next) {
    if (this.modified) {
      const answer = window.confirm('Do you really want to leave? you have unsaved changes!')
      if (answer) {
        next()
      } else {
        this.scrollToSave()
        next(false)
      }
    } else {
      next()
    }
  },
  methods: {
    async load() {
      this.loading = true;
      let application = await this.$api(`/application`)
      this.project_report_categories = application.project_report_categories;
      setTimeout(function() {
        this.modified = false
        this.loading = false;
      }.bind(this), 100)
    },
    async save() {
      this.loading = true;
      await this.$api({
        method: "POST",
        url: `/account/admin/application`,
        data: {
          project_report_categories: this.project_report_categories
        }
      })
      setTimeout(function() {
        this.modified = false
        this.loading = false;
      }.bind(this), 100)

    },
    scrollToSave() {
      setTimeout(function() {
        this.$vuetify.goTo("#save-btn", {
          duration: 300,
          offset: 100,
          easing: "easeInOutCubic",
        })
      }.bind(this), 100)
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
